export default [
  {
    airline: '8L',
    productCode: 'QLNTH',
    youngMin: 16,
    youngMax: 22,
    oldMin: 55,
    oldMax: Infinity
  },
  {
    airline: 'FU',
    productCode: 'FUQL',
    youngMin: 18,
    youngMax: 24,
    oldMin: 55,
    oldMax: Infinity
  }
]
